import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response, RequestOptions, Headers} from '@angular/http';
import { environment } from '../../../environments/environment';
// import * as $ from 'jquery';
declare var $ : any;
import swal from 'sweetalert2';
import { RRFormService } from '../../r-r-form.service';
import { NgxSpinnerService } from 'ngx-spinner';

const authToken = localStorage.getItem('currentUser');


@Component({
	selector: 'app-invoice-report',
	templateUrl: './invoice-report.component.html',
	styleUrls: ['./invoice-report.component.css']
})
export class InvoiceReportComponent implements OnInit {
	url = environment.url
	invoiceReportForm : FormGroup;
	query : any = null;
	export_query : any = null;
	response : any = null;
	report_data : any[] = [];
	rr_number :any[] = [];

	flat_info_table :any[] = [];
	total_weight : number = null;
	total_freight : number = null;


	// Product properties
	productDropdownList = [];
	productSelectedItems = [];
	productDropdownSettings = { 
		singleSelection: false, 
		text:"Select Product",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_product = [];

	// Consignor properties
	consignorDropdownList = [];
	consignorSelectedItems = [];
	consignorDropdownSettings = { 
		singleSelection: false, 
		text:"Select Consignor",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_consignor = [];

	// Station properties
	stationDropdownList = [];
	stationSelectedItems = [];
	stationDropdownSettings = {
		singleSelection: false, 
		text:"Select Station",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_station = [];

	// Account  properties
	accountDropdownList = [];
	accountSelectedItems = [];
	accountDropdownSettings = {
		singleSelection: false, 
		text:"Select On Account",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_account = [];

	// Party properties
	partyDropdownList = [];
	partySelectedItems = [];
	partyDropdownSettings = {
		singleSelection: false, 
		text:"Select Party",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_party = [];

	// Destination properties
	destinationDropdownList = [];
	destinationSelectedItems = [];
	destinationDropdownSettings = {
		singleSelection: false, 
		text:"Select Destination",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_destination = [];


	// Loading Point properties
	loadingDropdownList = [];
	loadingSelectedItems = [];
	loadingDropdownSettings = {
		singleSelection: false, 
		text:"Select Loading",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_loading = [];

	// Invoice By properties
	invoiceByDropdownList = [];
	invoiceBySelectedItems = [];
	invoiceByDropdownSettings = {
		singleSelection: false, 
		text:"Select Loading",
		selectAllText:'Select All',
		unSelectAllText:'UnSelect All',
		enableSearchFilter: true,
		classes:"myclass custom-class",
		badgeShowLimit : 3
	};
	post_invoice_by = [];


	constructor( private http : Http, private RRFormService:RRFormService, private spinner: NgxSpinnerService) { }

	ngOnInit() {

		this.getRRNumber();
		
		this.invoiceReportForm = new FormGroup({
			"rr_number" : new FormControl(null, Validators.required),
			"date_range" : new FormControl(null, Validators.required),			
			"product" : new FormControl(null, Validators.required),
			"consignor" : new FormControl(null, Validators.required),		 
			"station" : new FormControl(null, Validators.required),		 
			"on_account" : new FormControl(null, Validators.required),		 
			"party" : new FormControl(null, Validators.required),
			"destination" : new FormControl(null, Validators.required),
			"loading" : new FormControl(null, Validators.required),
			"invoice_by" : new FormControl(null, Validators.required)

		});

	

		this.getFilters();



		console.log(this.invoiceReportForm.value);	
	};

	getRRNumber(){
		this.rr_number=[];
		this.RRFormService.getAllRRForm()
		.subscribe( rr_number => {
			for(var i=0;i<rr_number.length;i++)
			{
				this.rr_number.push(rr_number[i]['rr_number']);
			}
		});
	};

	
	// *************** Product Functions ***************

	onProductSelect(item:any){
		console.log(item);
		console.log(this.productSelectedItems);
		this.convertProductOptionsToString();
	}

	OnProductDeSelect(item:any){
		console.log(item);
		console.log(this.productSelectedItems);
		this.convertProductOptionsToString();
	}

	onSelectAllProduct(items: any){
		console.log(items);
		this.convertProductOptionsToString();
	}

	onDeSelectAllProduct(items: any){
		console.log(items);
		this.convertProductOptionsToString();
	}

	convertProductOptionsToString(){
		this.post_product=[];
		for ( var i=0; i<this.productSelectedItems.length; i++ ){
			this.post_product.push(this.productSelectedItems[i]["itemName"]);
		}
		console.log(this.post_product);
	}

	// *************** Consignor Functions ***************

	onConsignorSelect(item:any){
		console.log(item);
		console.log(this.consignorSelectedItems);
		this.convertConsignorOptionsToString();
	}

	OnConsignorDeSelect(item:any){
		console.log(item);
		console.log(this.consignorSelectedItems);
		this.convertConsignorOptionsToString();
	}

	onSelectAllConsignor(items: any){
		console.log(items);
		this.convertConsignorOptionsToString();
	}

	onDeSelectAllConsignor(items: any){
		console.log(items);
		this.convertConsignorOptionsToString();
	}

	convertConsignorOptionsToString(){
		this.post_consignor=[];
		for ( var i=0; i<this.consignorSelectedItems.length; i++ ){
			this.post_consignor.push(this.consignorSelectedItems[i]["itemName"]);
		}
		console.log(this.post_consignor);
	}

	// *************** Station Functions ***************

	onStationSelect(item:any){
		console.log(item);
		console.log(this.stationSelectedItems);
		this.convertStationOptionsToString();
	}

	OnStationDeSelect(item:any){
		console.log(item);
		console.log(this.stationSelectedItems);
		this.convertStationOptionsToString();
	}

	onSelectAllStation(items: any){
		console.log(items);
		this.convertStationOptionsToString();
	}

	onDeSelectAllStation(items: any){
		console.log(items);
		this.convertStationOptionsToString();
	}

	convertStationOptionsToString(){
		this.post_station=[];
		for ( var i=0; i<this.stationSelectedItems.length; i++ ){
			this.post_station.push(this.stationSelectedItems[i]["itemName"]);
		}
		console.log(this.post_station);
	}

	// *************** Account Functions ***************

	onAccountSelect(item:any){
		console.log(item);
		console.log(this.accountSelectedItems);
		this.convertAccountOptionsToString();
	}

	OnAccountDeSelect(item:any){
		console.log(item);
		console.log(this.accountSelectedItems);
		this.convertAccountOptionsToString();
	}

	onSelectAllAccount(items: any){
		console.log(items);
		this.convertAccountOptionsToString();
	}

	onDeSelectAllAccount(items: any){
		console.log(items);
		this.convertAccountOptionsToString();
	}

	convertAccountOptionsToString(){
		this.post_account=[];
		for ( var i=0; i<this.accountSelectedItems.length; i++ ){
			this.post_account.push(this.accountSelectedItems[i]["itemName"]);
		}
		console.log(this.post_account);
	}

	// *************** Party Functions ***************

	onPartySelect(item:any){
		console.log(item);
		console.log(this.partySelectedItems);
		this.convertPartyOptionsToString();
	}

	OnPartyDeSelect(item:any){
		console.log(item);
		console.log(this.partySelectedItems);
		this.convertPartyOptionsToString();
	}

	onSelectAllParty(items: any){
		console.log(items);
		this.convertPartyOptionsToString();
	}

	onDeSelectAllParty(items: any){
		console.log(items);
		this.convertPartyOptionsToString();
	}

	convertPartyOptionsToString(){
		this.post_party=[];
		for ( var i=0; i<this.partySelectedItems.length; i++ ){
			this.post_party.push(this.partySelectedItems[i]["itemName"]);
		}
		console.log(this.post_party);
	}

	// *************** Destination Functions ***************

	onDestinationSelect(item:any){
		console.log(item);
		console.log(this.destinationSelectedItems);
		this.convertDestinationOptionsToString();
	}

	OnDestinationDeSelect(item:any){
		console.log(item);
		console.log(this.destinationSelectedItems);
		this.convertDestinationOptionsToString();
	}

	onSelectAllDestination(items: any){
		console.log(items);
		this.convertDestinationOptionsToString();
	}

	onDeSelectAllDestination(items: any){
		console.log(items);
		this.convertDestinationOptionsToString();
	}

	convertDestinationOptionsToString(){
		this.post_destination=[];
		for ( var i=0; i<this.destinationSelectedItems.length; i++ ){
			this.post_destination.push(this.destinationSelectedItems[i]["itemName"]);
		}
		console.log(this.post_destination);
	}


	// *************** Loading Functions ***************

	onLoadingSelect(item:any){
		console.log(item);
		console.log(this.loadingSelectedItems);
		this.convertLoadingOptionsToString();
	}

	OnLoadingDeSelect(item:any){
		console.log(item);
		console.log(this.loadingSelectedItems);
		this.convertLoadingOptionsToString();
	}

	onSelectAllLoading(items: any){
		console.log(items);
		this.convertLoadingOptionsToString();
	}

	onDeSelectAllLoading(items: any){
		console.log(items);
		this.convertLoadingOptionsToString();
	}

	convertLoadingOptionsToString(){
		this.post_loading=[];
		for ( var i=0; i<this.loadingSelectedItems.length; i++ ){
			this.post_loading.push(this.loadingSelectedItems[i]["itemName"]);
		}
		console.log(this.post_loading);
	}

	// *************** Invoice By Functions ***************

	onInvoiceBySelect(item:any){
		console.log(item);
		console.log(this.invoiceBySelectedItems);
		this.convertInvoiceByOptionsToString();
	}

	OnInvoiceByDeSelect(item:any){
		console.log(item);
		console.log(this.invoiceBySelectedItems);
		this.convertInvoiceByOptionsToString();
	}

	onSelectAllInvoiceBy(items: any){
		console.log(items);
		this.convertInvoiceByOptionsToString();
	}

	onDeSelectAllInvoiceBy(items: any){
		console.log(items);
		this.convertInvoiceByOptionsToString();
	}

	convertInvoiceByOptionsToString(){
		this.post_invoice_by=[];
		for ( var i=0; i<this.invoiceBySelectedItems.length; i++ ){
			this.post_invoice_by.push(this.invoiceBySelectedItems[i]["itemName"]);
		}
		console.log(this.post_invoice_by);
	}







	getFilters(){
		console.log(this.invoiceReportForm.value);

		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });

		const path = this.url + '/reports/invoices';
		this.http.get(path, options)
		.subscribe(res=>{
			console.log(res.json());
			
			this.report_data = res.json();

			this.fillProductFilters(this.report_data["filters"]["product"]);
			this.fillConsignorFilters(this.report_data["filters"]["consignor"]);
			this.fillStationFilters(this.report_data["filters"]["station"]);
			// this.fillAccountFilters(this.report_data["filters"]["on_account"]);
			// this.fillPartyFilters(this.report_data["filters"]["party"]);
			// this.fillDestinationFilters(this.report_data["filters"]["destination"]);
			this.fillLoadingFilters(this.report_data["filters"]["loading"]);
			this.fillInvoiceByFilters(this.report_data["filters"]["invoice_by"]);
				
			console.log(this.report_data)
		});
	
	};

	fillProductFilters(product_options){
		this.productDropdownList = [];
		for ( var i=0; i<product_options.length; i++ ){
			this.productDropdownList.push({"id" :i, "itemName" : product_options[i]});
		}
	};

	fillConsignorFilters(consignor_options){
		this.consignorDropdownList = [];
		for ( var i=0; i<consignor_options.length; i++ ){
			this.consignorDropdownList.push({"id" :i, "itemName" : consignor_options[i]});
		}
	};

	fillStationFilters(station_options){
		this.stationDropdownList = [];
		for ( var i=0; i<station_options.length; i++ ){
			this.stationDropdownList.push({"id" :i, "itemName" : station_options[i]});
		}
	};

	fillAccountFilters(account_options){
		this.accountDropdownList = [];
		for ( var i=0; i<account_options.length; i++ ){
			this.accountDropdownList.push({"id" :i, "itemName" : account_options[i]});
		}
	};

	fillPartyFilters(party_options){
		this.partyDropdownList = [];
		for ( var i=0; i<party_options.length; i++ ){
			this.partyDropdownList.push({"id" :i, "itemName" : party_options[i]});
		}
	};

	fillDestinationFilters(destination_options){
		this.destinationDropdownList = [];
		for ( var i=0; i<destination_options.length; i++ ){
			this.destinationDropdownList.push({"id" :i, "itemName" : destination_options[i]});
		}
	};


	fillLoadingFilters(loading_options){
		this.loadingDropdownList = [];
		for ( var i=0; i<loading_options.length; i++ ){
			this.loadingDropdownList.push({"id" :i, "itemName" : loading_options[i]});
		}
	};

	fillInvoiceByFilters(invoice_by_options){
		console.log(invoice_by_options);
		this.invoiceByDropdownList = [];
		for ( var i=0; i<invoice_by_options.length; i++ ){
			this.invoiceByDropdownList.push({"id" :i, "itemName" : invoice_by_options[i]});
		}
	};

	filteredData(){
		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });

		this.query = this.queryBuilder();
		this.export_query = this.query;
		console.log(this.query);

		const path = this.url + '/reports/invoices/filters';
		this.http.post(path, this.query, options)
		.subscribe(res=>{
			this.report_data["invoice_list"] = res.json();	
			console.log(this.report_data);
			if(this.report_data.length == 0){
				swal('Result Not Found', 'Records for the options selected may not be available', 'warning');
			}
			this.total_freight = this.report_data["invoice_list"]["total_freight"]
			this.total_weight = this.report_data["invoice_list"]["total_weight"]
			console.log(this.report_data);
			this.flat_info_table = this.report_data["invoice_list"]["invoices"];
		});
	};

	queryBuilder(){
		var post_query={}

		if(!this.invoiceReportForm.get("rr_number").value){
			console.log("empty rr")
			delete  post_query["rr_number"]
		}
		else{
			post_query["rr_number"] = this.invoiceReportForm.get("rr_number").value;
		}

		if(!this.invoiceReportForm.get("date_range").value){
			console.log("empty date_range")
			delete  post_query["date_range"]
		}
		else{
			post_query["date_range"] = this.invoiceReportForm.get("date_range").value;
		}

		// Product
		if(this.invoiceReportForm.get("product").value == 0 ){
			console.log("empty product")
			delete post_query["product"]
		}
		else{
			post_query["product"] = this.post_product;
		}

		// Consignor
		if(this.invoiceReportForm.get("consignor").value == 0 ){
			console.log("empty consignor")
			delete post_query["consignor"]
		}
		else{
			post_query["consignor"] = this.post_consignor;
		}

		// Station
		if(this.invoiceReportForm.get("station").value == 0 ){
			console.log("empty station")
			delete post_query["station"]
		}
		else{
			post_query["station"] = this.post_station;
		}

		// // Account
		// if(this.invoiceReportForm.get("on_account").value == 0 ){
		// 	console.log("empty on_account")
		// 	delete post_query["on_account"]
		// }
		// else{
		// 	post_query["on_account"] = this.post_account;
		// }

		// // Party
		// if(this.invoiceReportForm.get("party").value == 0 ){
		// 	console.log("empty party")
		// 	delete post_query["party"]
		// }
		// else{
		// 	post_query["party"] = this.post_party;
		// }

		// // Destination
		// if(this.invoiceReportForm.get("destination").value == 0 ){
		// 	console.log("empty destination")
		// 	delete post_query["destination"]
		// }
		// else{
		// 	post_query["destination"] = this.post_destination;
		// }


		// Loading
		if(this.invoiceReportForm.get("loading").value == 0 ){
			console.log("empty loading")
			delete post_query["loading"]
		}
		else{
			post_query["loading"] = this.post_loading;
		}

		// Invoice By
		if(this.invoiceReportForm.get("invoice_by").value == 0 ){
			console.log("empty invoice_by")
			delete post_query["invoice_by"]
		}
		else{
			post_query["invoice_by"] = this.post_invoice_by;
		}

		console.log(post_query);
		return post_query
	};

	exportdData(){
		this.spinner.show();
		const headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', `${authToken}`);
		const options = new RequestOptions({ headers: headers });

		const path = this.url + "/reports/invoices/export";
		this.http.post(path, this.export_query, options)
		.subscribe(res=>{
			this.response = res.json();	
			console.log(res.json())
			if(this.response["status"]){
				swal('Report Exported Successfully', 'Excel file is mailed to your register email-id', 'success');
				this.spinner.hide();
			}
			else{
				swal('Oops!', 'Something went wrong on the page!', 'error');
				this.spinner.hide();
			}
		},error=>{
			swal('Oops!', 'Please select options for Excel file', 'error');
			this.spinner.hide();
		});
	};


}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/reports/invoice-report/invoice-report.component.ts